<template>
  <div :class="wrapperClass">
    <div class="flex items-center">
      <SfSwitch
        v-bind="$attrs"
        :id="`${id}-switch`"
        v-model="value"
        :data-testid="`${id}-switch`"
        :disabled="disabled"
        class="checked:!border-primary-500 checked:!bg-primary-500 hover:checked:!border-primary-800 hover:checked:!bg-primary-800 active:checked:!border-primary-900 active:checked:!bg-primary-900"
      />
      <slot v-if="!label" />
      <UiText
        v-else
        type="label"
        :for="`${id}-switch`"
        class="ml-3 cursor-pointer"
        :class="[{ '!text-disabled-500': disabled }]"
      >
        {{ label }}
      </UiText>
    </div>
    <UiHelpText v-if="helpText" :text="helpText" />
  </div>
</template>

<script setup lang="ts">
import type { SwitchProps } from '~/components/ui/Switch/types';

const props = defineProps<SwitchProps>();

const value = ref<boolean>(props.checked);

defineOptions({
  inheritAttrs: false,
});
</script>
